<template>
  <wb-slider show-dot-navigation class="ti-whatsnext">
    <template v-for="item in $t('i18n.whatsNext')">
      <div
        v-if="item.headline && item.copy"
        class="ti-whatsnext__wb-slider-item wb-slider__item tile"
        :key="item.headline"
      >
        <div class="ti-whatsnext__inner">
          <wb-aspect-ratio ratio="4x3">
            <picture>
              <img :src="$parseSrc(item.image)" />
            </picture>
          </wb-aspect-ratio>

          <div class="ti-whatsnext__infos">
            <h4>{{ item.headline }}</h4>
            <p>{{ item.copy }}</p>
          </div>
        </div>
      </div>
    </template>
  </wb-slider>
</template>

<script lang="ts" setup>
import setup from '../../composables/setup';

const { $parseSrc } = setup();
</script>

<style lang="scss" src="./whatsnext.scss"></style>
